
export type MediaBreakpoint = 'sm' | 'md' | 'lg' | 'xl';

export function mediaBreakpointUp(breakpoint: MediaBreakpoint): boolean {
  const width = window.innerWidth;

  // Bootstrap breakpoints can be found at:
  // https://getbootstrap.com/docs/4.3/layout/overview/
  switch (breakpoint) {
    case 'sm':
      return width >= 576;
    case 'md':
      return width >= 768;
    case 'lg':
      return width >= 992;
    case 'xl':
      return width >= 1200;
    default:
      return false;
  }
}
